module.exports = __webpack_public_path__ + "media/images/gift-thanks-writer-bg-onigiri@2x-5aa53c1746158d74dc0daac0d33e1c3d.png";